import "./animation";
import "./menu";
import "./productCart";
import "./cart";
import Tabs from "./tabs";

new Tabs("more-info");
